<template>
    <div>
        <h2 class="ix-page-title-secondary">Commandes fournisseurs associées</h2>
        <div class="ix-table-box" v-show="company_id && company_id != null">
            <table class="ix-table ix-table-sm">
                <thead>
                    <tr>
                        <th>Numéro</th>
                        <th>Montant total HT</th>
                        <th>Montant total TTC</th>
                        <th>Montant affecté TTC</th>
                        <th class="text-right">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(expense, index) in expenses" :key="index" v-if="!loading">
                        <td>
                            {{ expense.full_designation }}
                            <input type="hidden" :name="'expenses[' + index + '][id]'" v-model="expense.id" required>
                            <input type="hidden" :name="'expenses[' + index + '][full_designation]'"
                                v-model="expense.full_designation" required>
                        </td>
                        <td class="text-center">
                            {{ currency(expense.total_ht) }}
                            <input type="hidden" :name="'expenses[' + index + '][id]'" v-model="expense.id" required>
                            <input type="hidden" :name="'expenses[' + index + '][total_ht]'" v-model="expense.total_ht"
                                required>
                        </td>
                        <td class="text-center">
                            {{ currency(expense.total_ttc) }}
                            <input type="hidden" :name="'expenses[' + index + '][id]'" v-model="expense.id" required>
                            <input type="hidden" :name="'expenses[' + index + '][total_ttc]'" v-model="expense.total_ttc"
                                required>
                        </td>
                        <td>
                            <div class="input-group input-group-sm" style="max-width: 300px">
                                <input type="number" class="form-control text-right"
                                    :name="'expenses[' + index + '][amount]'" v-model="expense.amount" required step="0.01">
                                <div class="input-group-append">
                                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                </div>
                            </div>
                        </td>
                        <td class="text-right">
                            <button type="button" class="btn btn-sm transparent" @click="deleteRowExpense(index)">
                                <i class="far fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                    <tr v-if="loading">
                        <td colspan="3" class="text-center">
                            <i class="far fa-circle-notch fa-spin"></i>
                        </td>
                    </tr>
                    <tr v-show="!loading">
                        <td colspan="5">
                            <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control"
                                id="expenseSearchInput" type="text" v-model="expense">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-show="company_id && company_id != null" class="alert alert-warning mt-2"
            v-if="total_expenses !== total_ttc && expenses.length > 0">
            <strong>Avertissement:</strong>
            La somme des montants TTC des commandes fournisseurs ne correspond pas au total TTC renseigné
        </div>

        <div class="row mt-4" v-show="company_id && company_id != null">
            <div class="col-sm-12 col-md-12 col-lg-8 offset-lg-4">
                <div class="ix-trade-totals">
                    <table class="ix-table ix-table-transparent">
                        <tbody>
                            <tr>
                                <td style="width: 150px;" class="ix-text-bold">Total HT</td>
                                <td class="text-right">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" required
                                            v-model="total_ht" id="total_ht" name="total_ht">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-show="isSubcontractor == 1" class="alert alert-warning mt-2">
                        L'auto-liquidation de TVA a été associée à ce fournisseur, indiquez le montant de la TVA à auto-liquider.
                    </div>

                    <div v-show="isIntraEu == 1 || isExtraEu == 1" class="alert alert-warning mt-2">
                        {{msgTvaIntra}}
                    </div>

                    <table class="ix-table ix-table-no-borders">
                        <tbody>
                            <tr>
                                <td colspan="2" class="ix-text-bold">TVA</td>
                            </tr>
                            <tr v-for="(vat, index) in vats" v-bind:key="index">
                                <td style="width: 150px;">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-center" required min="0"
                                            v-model="vat.rate" :name="'vats[' + index + '][rate]'">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" required
                                            v-model="vat.amount" :name="'vats[' + index + '][amount]'">
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                            <button class="ix-btn ix-btn-sm icon" type="button" @click="deleteRow(index)"
                                                v-if="vats.length > 1">
                                                <i class="far fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2">
                                    <button @click="addRow(null)" type="button" class="ix-btn link"><i
                                            class="far fa-plus"></i> Ajouter une TVA</button>
                                </td>
                            </tr>
                            <tr>
                                <td class="ix-text-bold">Total TVA</td>
                                <td class="text-right">
                                    {{ currency(total_vat) }}
                                    <input type="hidden" v-model="total_vat" name="total_vat">
                                </td>
                            </tr>
                        </tbody>
                    </table>

                 

                    <table class="ix-table ix-table-transparent">
                        <tbody>
                            <tr>
                                <td style="width: 150px;" class="ix-text-bold">Total TTC</td>
                                <td class="text-right">
                                    <div class="input-group input-group-sm">
                                        <input type="number" step="0.01" class="form-control text-right" v-model="total_ttc"
                                            id="total_ttc" name="total_ttc" disabled>
                                        <div class="input-group-append">
                                            <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                                        </div>
                                        <input type="hidden" v-model="total_ttc" name="total_ttc">
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <div v-if="company_id == ''" class="alert alert-warning">
            Veuillez choisir un fournisseur pour choisir une commande fournisseur
        </div>

       

    </div>
</template>

<script>
import $ from "jquery";

export default {
    name: 'bill-totals-form',
    props: ['totalHt', 'oldVats', 'expenseRoute', 'oldExpenses'],
    data() {
        return {
            vats: [],
            total_ht: this.totalHt ? this.totalHt : 0,
            loading: true,
            expense: null,
            expenses: [],
            company_id: null,
            isSubcontractor:false,
            isIntraEu:false,
            isExtraEu:false,
            msgTvaIntra: '',
        }
    },
    computed: {
        total_vat: function () {
            var sum = 0;
            
            if(this.isSubcontractor == 0 && !this.isIntraEu && !this.isExtraEu)
                this.vats.forEach(vat => sum += parseFloat(vat.amount));
            return sum;
        },
        total_ttc: function () {
            return this.roundCurrency(parseFloat(this.total_ht) + parseFloat(this.total_vat), 2);
        },
        total_expenses: function () {
            var sum = 0;
            this.expenses.forEach(expense => sum += parseFloat(expense.amount));
            return this.roundCurrency(sum, 2);
        },
        total_expenses_ttc: function () {

        }
    },
    methods: {
        addRow: function (vat) {
            this.vats.push({
                'rate': vat != null ? vat.rate : 20,
                'amount': vat != null ? vat.amount : 0
            })

        },
        deleteRow: function (index) {
            this.vats.splice(index, 1)
            if (this.vats.length == 0) {
                this.addRow(null)
            }
        },
        addRowExpense(expense) {
            if (this.getCurrentSelectedExpensesId().includes(expense.id) == false) {
                this.expenses.push({
                    id: expense.id,
                    full_designation: expense.full_designation,
                    amount: expense.amount ? expense.amount : (expense.pivot ? expense.pivot.amount : expense.total_remaining),
                    total_ht: expense.total_ht,
                    total_ttc: expense.total_ttc
                })
            }
        },
        deleteRowExpense(index) {
            this.expenses.splice(index, 1)
            if (this.expenses.length == 0) {
                this.addRowExpense()
            }
        },
        getCurrentSelectedExpensesId: function () {
            return this.expenses.map(expense => expense.id);
        },
        initExpenseInput: function () {
            $("#expenseSearchInput").autocomplete({
                minLength: 0,
                source: (request, response) => {
                    $.ajax({
                        url: this.expenseRoute,
                        type: 'get',
                        dataType: 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: { q: request.term, '!id': this.getCurrentSelectedExpensesId().join(';'), 'valid': 'only', 'company_id': this.company_id != null ? this.company_id : null },
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.full_designation,
                                    value: item.full_designation,
                                    formatted_total_remaining: this.currency(item.total_remaining),
                                    total_ht: item.total_ht,
                                    formatted_total_ht: this.currency(item.total_ht),
                                    total_ttc: item.total_ttc,
                                    formatted_total_ttc: this.currency(item.total_ttc),
                                })
                            }))
                        }
                    });
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = (ul, item) => {
                        var html = `<div class="d-flex align-items-center justify-content-between">
                                        <span>${item.full_designation} (${item.company.name})</span>
                                        <span>${item.formatted_total_ht} HT</span>
                                        <span>${item.formatted_total_ttc} TTC</span>
                                        <span>Restant facturable : ${item.formatted_total_remaining} TTC</span>
                                    </div>`;
                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                change: (e, item) => {
                    if (!item.item) {
                        $(e.target).val("");
                        this.expense = null
                    }
                },
                select: (e, item) => {
                    if (item.item) {
                        this.addRowExpense(item.item)

                        $(e.target).val("")
                        this.expense = null;
                    }
                }
            }).focus(() => {
                $("#expenseSearchInput").autocomplete("search", '');
            });
        }
    },
    mounted() {
        const vm = this;
        if ($('#company_id').val() != null || $('#company_id').val() != '') {
            vm.company_id = $('#company_id').val();
            vm.isSubcontractor = $('#is_subcontractor').val();
            let area = $('#type_area').val()
            vm.isIntraEu = area == 2 ? true : false;
            vm.isExtraEu = area == 3 ? true : false;
            if(area == 2)
                vm.msgTvaIntra = 'Vous avez précisé que ce fournisseur est localisé en union-européenne. Indiquez la TVA à déclarer'
            if(area == 3)
                vm.msgTvaIntra =  'Vous avez précisé que ce fournisseur est localisé en dehors de l\'union-européenne. Indiquez la TVA à déclarer';
        }
        $('#company_id').on('change', function () {
            setTimeout(() => {
                vm.company_id = $('#company_id').val();
                vm.isSubcontractor = $('#is_subcontractor').val();
                let area = $('#type_area').val()
                vm.isIntraEu = area == 2 ? true : false; 
                vm.isExtraEu = area == 3 ? true : false;
                if(area == 2)
                    vm.msgTvaIntra = 'Vous avez précisé que ce fournisseur est localisé en union-européenne. Indiquez la TVA à déclarer'
                if(area == 3)
                    vm.msgTvaIntra =  'Vous avez précisé que ce fournisseur est localisé en dehors de l\'union-européenne. Indiquez la TVA à déclarer';
        
                vm.expenses = [];
            }, "500"); 
        })


        this.initExpenseInput();
        const jsonVatsBackup = JSON.parse(this.oldVats);
        const jsonExpenseBackup = JSON.parse(this.oldExpenses);
        if (Array.isArray(jsonVatsBackup)) {
            if (jsonVatsBackup.length > 0) {
                jsonVatsBackup.forEach(vat => {
                    this.addRow(vat)
                })
            }
        }
        if (Array.isArray(jsonExpenseBackup)) {
            if (jsonExpenseBackup.length > 0) {
                jsonExpenseBackup.forEach(expense => {
                    this.addRowExpense(expense)
                })
            }
        }
        this.loading = false
    }
}
</script>